<template>
  <section class="tech-advantage">
    <h2 class="section-title">技术优势</h2>
    <p class="subtitle">行业领先的 AI 算法能力</p>

    <div class="tech-content">
      <div class="tech-left">
        <div class="core-tech">
          <h3>核心技术突破</h3>
          <div class="tech-item">
            <h4>静动双态融合算法</h4>
            <p>静态定位毫米级精度，动态追踪全轨迹预判，识别准确率 99.99%</p>
          </div>
          <div class="tech-item">
            <h4>多模态决策大模型</h4>
            <p>融合物理预估、玩家行为与环境变量，精准应对高速击球</p>
          </div>
          <div class="tech-item">
            <h4>连续事件级引擎</h4>
            <p>支持 16 种花式球识别，由球瞬间联动灯光、音效</p>
          </div>
        </div>

        <div class="tech-team">
          <h3>技术团队</h3>
          <p>由人工智能专家与台球领域资深人士联合组建，既懂算法，更懂台球</p>
          <div class="team-stats">
            <div class="stat-item">
              <div class="number">50+</div>
              <div class="desc">AI 算法专家</div>
            </div>
            <div class="stat-item">
              <div class="number">20+</div>
              <div class="desc">台球领域专家</div>
            </div>
          </div>
        </div>
      </div>

      <div class="tech-bottom">
        <div class="stat-card">
          <div class="big-number">99.99%</div>
          <div class="stat-title">识别准确率</div>
          <p>静态定位毫米级精度，动态追踪全轨迹预判</p>
        </div>
        <div class="stat-card">
          <div class="big-number">16+</div>
          <div class="stat-title">花式球识别</div>
          <p>支持多种花式球玩法，实时联动反馈</p>
        </div>
        <div class="stat-card">
          <div class="big-number">&lt;0.5cm</div>
          <div class="stat-title">数据误差</div>
          <p>高精度传感器实时捕捉球速与落点</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TechAdvantage'
}
</script>

<style scoped>
.tech-advantage {
  padding: 4rem 5%;
  background-color: #fff;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.tech-content {
  max-width: 1200px;
  margin: 0 auto;
}

.tech-left {
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
}

.core-tech, .tech-team {
  flex: 1;
  background: linear-gradient(to bottom right, #fff1f1, #f8f9fa);
  padding: 2rem;
  border-radius: 12px;
}

.core-tech h3, .tech-team h3 {
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.tech-item {
  margin-bottom: 1.5rem;
}

.tech-item h4 {
  color: #ff0000;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.tech-item p {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
}

.tech-team p {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.team-stats {
  display: flex;
  gap: 2rem;
}

.stat-item {
  flex: 1;
  background: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
}

.stat-item .number {
  color: #ff0000;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.stat-item .desc {
  color: #666;
  font-size: 0.9rem;
}

.tech-bottom {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
}

.stat-card {
  flex: 1;
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}

.big-number {
  color: #ff0000;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.stat-title {
  color: #333;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.stat-card p {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .tech-left {
    flex-direction: column;
  }

  .tech-bottom {
    flex-direction: column;
  }

  .team-stats {
    justify-content: space-around;
  }
}
</style>